var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "95huuhvg5b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.913725 0 0 0 0 0.329412 0 0 0 0 0.592157 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vukc780nka",
    d: "M29 61c16.016 0 29-12.984 29-29S44.516 0 28.5 0 0 15.984 0 32s12.984 29 29 29z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-808 -361) translate(570 361) translate(238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ahlax3ivuc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vukc780nka"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#95huuhvg5b)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#ahlax3ivuc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE4C36",
    d: "M5.226 5.994c-.637-.03-1.255-.16-1.72-.393C.96 3.956.548 2.165 3.273 2.874c.234.017.403.068.505.154.535.391 1.127.599 1.723.602.596-.003 1.187-.21 1.724-.602.101-.086.27-.137.504-.154 2.724-.709 2.312 1.082-.235 2.727C6.963 5.867 6.231 6 5.5 6zM7.341.232c1.084.902 1.815 1.36 2.193 1.375.425.014.769-.025 1.031-.116.34-.048.48.03.423.232-.327.54-.996.762-2.006.67-.4-.013-.82-.072-1.254-.181-.234.018-.403.069-.504.154-.545.568-1.135.851-1.724.854l-.177-.01c-.53-.052-1.057-.333-1.546-.844-.102-.085-.271-.136-.505-.154-.435.109-.853.168-1.254.18-1.01.093-1.679-.13-2.006-.669-.057-.202.083-.28.423-.232.262.091.606.13 1.032.116.377-.015 1.108-.473 2.192-1.375.287-.275.53-.306.727-.091.36.298.737.446 1.114.446.377 0 .754-.148 1.114-.446.198-.215.44-.184.727.09z",
    transform: "translate(23 28.893)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E95497",
    d: "M41.395 23.343c-.534 1.219-1.17 2.427-2.327 3.453 2.243-5.125 1.353-10.013-2-12.465-1.888 3.02-5.165 5.149-8.894 5.884 2.22-1.317 4.009-3.216 5.038-5.523-2.46 4.299-7.575 6.457-12.429 5.66 3.07-.589 5.855-2.34 7.598-4.941-1.668 1.795-5.915 3.73-10.972 3.502-.844 5.842 1.323 12.075 6.514 15.867-2.3-.962-4.077-1.767-5.376-3.9 1.32 3.133 4.174 5.657 7.176 7.242 2.625 1.386 2.929 1.386 5.554 0 5.453-2.879 9.06-8.83 10.118-14.779zm-5.729 20.544c1.837 1.36 4.6 1.808 6.805 2.238 2.312.452 4.791.964 6.763 2.32C52.185 50.475 53 53.752 53 57.16l-21.723 12.69L4 58v-.839c0-3.409.814-6.687 3.766-8.716.589-.405 1.222-.735 1.884-1.01.085.763.29 1.507.601 2.21 1.727 3.89 5.61 6.18 9.702 6.834l1.75.28-.89-1.53c-.935-1.609-1.586-3.358-.79-5.167.113-.257.247-.506.394-.748 3.569 3.182 9.33 5.249 15.83 5.249 5.543 0 10.549-1.503 14.115-3.918-4.75-6.138-17.33-1.038-18.072-12.124-.204.118-.41.233-.62.343-2.88 1.52-3.46 1.52-6.34 0-.184-.098-.367-.199-.548-.302-.145 6.086-4.149 8.024-5.529 11.162-.919 2.09-.235 4.09.833 5.927-3.787-.606-7.45-2.707-9.066-6.347-2.522-5.683 4.12-10.722 2.936-16.279-.473-2.218-1.613-4.574-2.64-7.13C6.492 13.905 14.26-1.137 28.62.068c19.968 1.676 18.774 32.125 5.846 42.618.325.442.72.845 1.2 1.201z",
    mask: "url(#ahlax3ivuc)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWoman);
export default __webpack_public_path__ + "static/media/icon-woman.c41f349c368d330ec5d8c87c7bf68608.svg";
export { ForwardRef as ReactComponent };